import React from 'react';
import { Helmet } from 'react-helmet-async';
import seoConfig from './seoConfig';

const SEO = ({
  title,
  description,
  canonical,
  image,
  type = 'website',
  noindex = false,
  jsonLd = null,
  locale = 'en_US',
}) => {
  const metaTitle = title ? `${title} | ${seoConfig.siteName}` : seoConfig.defaultTitle;
  const metaDescription = description || seoConfig.defaultDescription;
  const metaImage = image || seoConfig.defaultImage;
  const url = canonical || seoConfig.siteUrl;

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content="video production, visual direction, real-time content, Miami, Jiddu Films, Matías Piccinini, post-production, mobile studio, BTS, sports coverage, festivals, global campaigns" />
      <meta name="author" content="Matías Piccinini" />
      <meta name="robots" content="index, follow" />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {url && <link rel="canonical" href={url} />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      {url && <meta property="og:url" content={url} />}
      {metaImage && <meta property="og:image" content={metaImage} />} 
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={seoConfig.siteName} />
      <meta property="og:locale" content={locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {metaImage && <meta name="twitter:image" content={metaImage} />} 
      <meta name="twitter:site" content="@jiddufilms" />
      <meta name="twitter:creator" content="@jiddufilms" />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;


